import { render, staticRenderFns } from "./fccObjetosAcao.vue?vue&type=template&id=b061610a"
import script from "./fccObjetosAcao.vue?vue&type=script&lang=js"
export * from "./fccObjetosAcao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports